module.exports = __webpack_public_path__ + "f176996ecc3222e5b3cfe9b1dd95574e.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/fonts/openbooksmd-webfont.svg
// module id = 992
// module chunks = 0